import { ClockTheme } from "../lib/colorThemes";

interface SwitcherProps {
  changeHandler: (themeName: string) => void;
  theme: ClockTheme;
}

const ColorThemeSwitcher = ({ changeHandler, theme }: SwitcherProps) => {
  const btnClasses = "mr-2 text-sky-600 border border-stone-300 p-2 rounded-md";
  const btnActiveClasses =
    "mr-2 border border-slate-500 shadow-md p-2 rounded-md bg-slate-50 text-slate-600";

  const themeButtons = [
    {
      slug: "red-yellow",
      text: "Red/Yellow",
    },
    {
      slug: "blue-green",
      text: "Blue/Green",
    },
    {
      slug: "slate",
      text: "Slate",
    },
    {
      slug: "cyan",
      text: "Cyan",
    },
    {
      slug: "teal",
      text: "Teal",
    },
  ];

  return (
    <div className="flex flex-col">
      <div className="flex justify-center p-2 text-slate-500 font-medium">
        Color Themes
      </div>
      <div className="flex justify-center p-2">
        {themeButtons.map((btn) => {
          return (
            <button
              key={btn.slug}
              type="button"
              onClick={() => changeHandler(btn.slug)}
              className={
                theme.slug === btn.slug ? btnActiveClasses : btnClasses
              }
            >
              {btn.text}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export { ColorThemeSwitcher };
